import { Pipe, PipeTransform } from '@angular/core';
import { CategoryResponse } from './api-interfaces';

@Pipe({
  name: 'category'
})
export class CategoryPipe implements PipeTransform {

  transform(categories: CategoryResponse[]): string {
    if (categories.length <= 0) {
      return '';
    }
    return categories.reduce((prev, curr, index, all) => {
      let cat =  prev + curr.category_name;
      // if (index < all.length - 1) {
      //   cat += ', ';
      // }
      return cat;
    }, '');

  }

}



// WEBPACK FOOTER //
// /home/agira/Desktop/BU-Intra/agira-intranet-ui/src/app/skill-matrix/category.pipe.ts